import React from 'react';
import { Container } from 'react-bootstrap';

export const NotFoundPage = () => {
  return <Container>
    <h1>404 NOT FOUND</h1>
    <a href="/homes">Return to HomeSearch</a>
  </Container>;
}
